import { LoadableAfterPaint } from '@confluence/loadable';

export const PerformanceInsightsPage = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-confluencePerformanceInsightsPage" */ '../src/PerformanceInsightsPage.tsx'
			)
		).PerformanceInsightsPage,
});
